import React, { useCallback, useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { getLocale, getMessages } from './i18n';
import useAPI from './api';
import App from './App';

const LocalizedApp = function LocalizedApp() {
  const API = useAPI();
  const [translations, setTranslations] = useState(null);

  useEffect(() => {
    API.getTranslations(
      (res) => {
        const formattedTranslations = {};
        Object.keys(res).forEach((key) => {
          formattedTranslations[key.toUpperCase()] = res[key];
        });
        setTranslations(formattedTranslations);
      },
      () => {
        setTranslations({});
      }
    );
  }, []);

  const getUpdatedMessages = useCallback(
    () => getMessages(translations),
    [translations]
  );

  const handleIntlError = (err) => {
    //remove missing translation errors
    if (err.code === 'MISSING_TRANSLATION') {
      return;
    }

    console.error(err);
  };

  return (
    <IntlProvider
      locale={getLocale()}
      messages={getUpdatedMessages()}
      onError={handleIntlError}
    >
      <App />
    </IntlProvider>
  );
};

export default LocalizedApp;
